import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";
import { message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import SettingEmailTemplateFormComponent from "../components/SettingEmailTemplateForm";
import * as services from "../service/settingEmailTemplateApi";
import { getCompany } from "features/company/services/companyApi";
import { setCurrentCompanyProfile } from "features/company/slices/companySlice";
import { generateRandomString } from "utils/helper";

const SettingEmailTemplateForm = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const currentCompany = useSelector((state) => state.company.currentCompany);
    const currentCompanyProfile = useSelector((state) => state.company.currentCompanyProfile);
    const [initialValues, setInitialValues] = useState({});
    const [loading, setLoading] = useState(false);

    const loadRecord = useCallback(async () => {
        if (!id) return;
        try {
            const res = await services.getEmailTemplateList({});
            const list = res?.data?.content?.content ?? res?.data?.content ?? [];
            const record = list.find((e) => e.id === id);
            if (record) setInitialValues(record);
        } catch (e) {
            message.error("โหลดข้อมูลไม่สำเร็จ");
        }
    }, [id]);

    const loadCompanyProfile = useCallback(async () => {
        // ถ้ามีอยู่แล้วในสโตร์ (เคยเข้าหน้า Company Profile มาก่อน) ไม่ต้องยิงซ้ำ
        if (currentCompanyProfile?.companyLogo) return;
        try {
            const res = await getCompany({
                requestId: generateRandomString(),
                companyId: currentCompany,
            });
            dispatch(setCurrentCompanyProfile(res?.data?.content || res?.data || {}));
        } catch (e) {
            console.error(e);
        }
    }, [currentCompany, currentCompanyProfile, dispatch]);

    useEffect(() => {
        loadRecord();
    }, [loadRecord]);

    useEffect(() => {
        loadCompanyProfile();
    }, [loadCompanyProfile]);

    const onSubmit = async (values) => {
        try {
            setLoading(true);
            await services.saveEmailTemplate(id ? { id, ...values } : values);
            message.success("บันทึกเทมเพลตสำเร็จ");
            navigate("/masterdata/setting_email_template");
        } catch (e) {
            message.error("บันทึกไม่สำเร็จ");
        } finally {
            setLoading(false);
        }
    };

    return (
        <SettingEmailTemplateFormComponent
            isEdit={!!id}
            initialValues={initialValues}
            loading={loading}
            onSubmit={onSubmit}
            onCancel={() => navigate(-1)}
        />
    );
};

export default SettingEmailTemplateForm;